import { portfolioProfile } from "../content/portfolio";
import { navigate } from "../lib/navigation";
import type {
  AppearancePreference,
  ResolvedTheme,
} from "../lib/appearance";
import type { Route } from "../types";
import { AppearanceToggle } from "./AppearanceToggle";

interface SiteHeaderProps {
  route: Route;
  appearancePreference: AppearancePreference;
  resolvedTheme: ResolvedTheme;
  onCycleAppearance: () => void;
}

export function SiteHeader({
  route,
  appearancePreference,
  resolvedTheme,
  onCycleAppearance,
}: SiteHeaderProps) {
  return (
    <header className="site-header">
      <button
        className="identity"
        type="button"
        onClick={() => navigate("/")}
        aria-label="Return to the Curiosity Engine home"
        aria-current={route.kind === "home" ? "page" : undefined}
      >
        <span className="identity-mark" aria-hidden="true">
          <i />
          <i />
          <i />
        </span>
        <span>
          <strong>Johnny Leek</strong>
          <small>Curiosity Engine</small>
        </span>
      </button>

      <div className="header-actions">
        <nav aria-label="Portfolio">
          <button
            className={route.kind === "read" ? "is-active" : ""}
            type="button"
            aria-current={route.kind === "read" ? "page" : undefined}
            onClick={() => navigate("/read")}
          >
            Read
          </button>
          <button
            className={route.kind === "index" ? "is-active" : ""}
            type="button"
            aria-current={route.kind === "index" ? "page" : undefined}
            onClick={() => navigate("/index")}
          >
            Map
          </button>
          <a
            href={portfolioProfile.resumeUrl}
            target="_blank"
            rel="noreferrer"
            aria-label="Open Johnny Leek's resume PDF in a new tab"
          >
            Resume
          </a>
          <button
            className={route.kind === "contact" ? "is-active" : ""}
            type="button"
            aria-current={route.kind === "contact" ? "page" : undefined}
            onClick={() => navigate("/contact")}
          >
            Contact
          </button>
        </nav>
        <AppearanceToggle
          preference={appearancePreference}
          resolvedTheme={resolvedTheme}
          onCycle={onCycleAppearance}
        />
      </div>
    </header>
  );
}
